<script>

import { h } from 'vue';

export default {
  props: {
    content: {
      type: [Number, String, Object],
      required: false,
      default: null
    },
    keywords: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  render() {
    if (!this.content && this.content !== 0) {
      return;
    }

    return h('span', this.content);
  }
};
</script>
